import { Link } from "react-router-dom";
import { Linkedin, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { SERVICES, INDUSTRIES } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A1F44] text-slate-200 mt-12">
      <div className="sozos-container py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
          <div className="md:col-span-4">
            <Link to="/" className="flex items-center gap-3">
              <div className="bg-white rounded-sm flex items-center justify-center px-3 py-2">
                <img src="/brand/sozos-logo.png" alt="Sozos" className="h-10 w-auto" />
              </div>
              <div>
                <div className="font-display text-white font-bold text-xl">Global Services</div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-slate-400">Your Revenue Growth Partner</div>
              </div>
            </Link>
            <p className="mt-5 text-sm text-slate-300 leading-relaxed max-w-sm">
              We help ambitious companies generate qualified pipeline, expand into new markets,
              and build revenue engines that compound — at a fraction of the cost of in-house.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a data-testid="footer-linkedin" aria-label="LinkedIn" href="https://www.linkedin.com/company/sozos-global-services" target="_blank" rel="noreferrer" className="w-9 h-9 rounded-sm border border-white/20 flex items-center justify-center hover:bg-white hover:text-[#0A1F44] transition">
                <Linkedin className="w-4 h-4" />
              </a>
              <a data-testid="footer-email" aria-label="Email" href="mailto:info@sozos.in" className="w-9 h-9 rounded-sm border border-white/20 flex items-center justify-center hover:bg-white hover:text-[#0A1F44] transition">
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.22em] text-slate-400 mb-4">Services</h4>
            <ul className="space-y-2.5">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.slug}>
                  <Link
                    to="/services"
                    data-testid={`footer-service-${s.slug}`}
                    className="text-sm text-slate-300 hover:text-white link-underline"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.22em] text-slate-400 mb-4">Industries</h4>
            <ul className="space-y-2.5">
              {INDUSTRIES.slice(0, 6).map((i) => (
                <li key={i.slug}>
                  <Link
                    to="/industries"
                    data-testid={`footer-industry-${i.slug}`}
                    className="text-sm text-slate-300 hover:text-white link-underline"
                  >
                    {i.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.22em] text-slate-400 mb-4">Company</h4>
            <ul className="space-y-2.5">
              <li><Link data-testid="footer-link-about" to="/about" className="text-sm text-slate-300 hover:text-white link-underline">About</Link></li>
              <li><Link data-testid="footer-link-cases" to="/case-studies" className="text-sm text-slate-300 hover:text-white link-underline">Case Studies</Link></li>
              <li><Link data-testid="footer-link-ai" to="/ai-revenue-agents" className="text-sm text-slate-300 hover:text-white link-underline">AI Agents</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="text-sm text-slate-300 hover:text-white link-underline">Contact</Link></li>
            </ul>
            <div className="mt-6 flex items-start gap-2 text-xs text-slate-400">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
              <span>Coimbatore · Bengaluru, India</span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-slate-400">© {new Date().getFullYear()} Sozos Global Services. All rights reserved.</p>
          <Link to="/contact#book" data-testid="footer-cta-book" className="inline-flex items-center gap-2 text-sm text-white hover:text-blue-300 transition">
            Book a Growth Consultation <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </footer>
  );
}
